<template>
  <section class="navigation-component header comparer">
    <Navbar>
      <template #nav v-if="$store.getters.tokenValid" v-slot:actions>
        <button class="link-element bordered logout-button" @click="$store.dispatch('logOut')"><span>Uitloggen</span>
          <Icon icon="x-fa-arrow-right-from-bracket-regular" size="sm" />
        </button>
      </template>
    </Navbar>
    <transition :name="$route.meta.transition" mode="out-in">
      <div>
        <router-view :key="$route.name" />
      </div>
    </transition>
  </section>
</template>
<style lang="scss"></style>
<script>
import mijnkeuze from './mixin/mijnkeuze';
import Navbar from '../../vue-elements/navbar/Navbar.vue';
import Icon from '../../vue-elements/icon/Icon.vue';

export default {
  mixins: [
    mijnkeuze
  ],
  components: {
    Icon,
    Navbar,
  },
  created() {
    this.$watch('error', (payload) => {
      if (Object.keys(payload).length) {
        Object.keys(payload)
          .forEach((type) => {
            this.logAnalyticsEvent('mijnkeuze.error', {
              type: type,
              value: payload[type]
            });
          });
      }
    }, { deep: true });
    this.$watch('profile', (payload) => {
      Object.keys(payload)
        .forEach((type) => {
          this.logAnalyticsEvent('mijnkeuze.profile', {
            type: type,
            value: payload[type],
          });
        });
    }, { deep: true });
    this.$watch('account', (payload) => {
      Object.keys(payload)
        .forEach((type) => {
          this.logAnalyticsEvent('mijnkeuze.account', {
            type: type,
            value: payload[type],
          });
        });
    }, { deep: true });
  },
  data() {
    return {};
  },
};

</script>
